module.exports = __webpack_public_path__ + "img/img3.2bc25de9.png";